import { MdAdd } from "@react-icons/all-files/md/MdAdd";
import { MdDelete } from "@react-icons/all-files/md/MdDelete";
import { MdRemove } from "@react-icons/all-files/md/MdRemove";
import classNames from "classnames";
import { Link } from "react-router-dom-v5-compat";

import { Price } from "@onsite_app/MobileOrderingMenu/Atoms";
import { useFetchLiveItemCountdown } from "@onsite_app/MobileOrderingMenu/queries";

import { deleteCartItem, updateCartItem } from "../CartItem/cartItemRequests";
import { ItemCountdown } from "../Sections/Section";
import { useSession, useSessionDispatch } from "../Session/SessionContext";
import { CartItem } from "./schema";

export const PendingCartItem = ({
  cartItem,
  inSoldOutError,
}: {
  cartItem: CartItem;
  inSoldOutError?: boolean;
}) => {
  const dispatch = useSessionDispatch();
  const { cart } = useSession();
  const itemCountdownQuery = useFetchLiveItemCountdown(cartItem.itemId);

  const removeOrderItem = async () => {
    await deleteCartItem(cart.uuid, cartItem.id);
    dispatch({
      action: "removeCartItem",
      payload: { cartItemId: cartItem.id },
    });
  };
  const soldOut =
    inSoldOutError ||
    (itemCountdownQuery.data &&
      cartItem.multiplier > itemCountdownQuery.data.remainingCount);
  const canIncreaseMultiplier =
    !inSoldOutError &&
    cartItem.multiplier < (itemCountdownQuery.data?.remainingCount || Infinity);

  const updateMultiplier = (newMultiplier: number) => async () => {
    await updateCartItem({
      id: cartItem.id,
      cartId: cart.uuid,
      multiplier: newMultiplier,
    });
    dispatch({
      action: "updateCartItem",
      payload: {
        id: cartItem.id,
        multiplier: newMultiplier,
      },
    });
  };

  return (
    <div
      key={cartItem.id}
      className={classNames(
        "flex flex-wrap items-center gap-8 rounded-venue-brand bg-venue-tertiary p-12 text-base font-medium shadow-venue-brand-style",
        {
          "outline-2 outline-venue-highlight outline-solid": soldOut,
        },
      )}
    >
      {cartItem.itemHeroImageUrl && (
        <div className="flex-none">
          <div className="aspect-w-1 w-[80px] flex-none aspect-h-1">
            <img
              src={cartItem.itemHeroImageUrl}
              className="rounded-venue-brand object-cover"
            />
          </div>
        </div>
      )}
      <div className="flex-1">
        <div className="space-x-8 flex">
          <Link to={`/order-items/${cartItem.itemId}/${cartItem.id}`}>
            {cartItem.itemName}
          </Link>
          {soldOut && (
            <div className="flex items-center">
              <ItemCountdown count={itemCountdownQuery.data?.remainingCount} />
            </div>
            // <div className="flex items-center bg-venue-highlight text-venue-tertiary font-semibold text-xs rounded-venue-brand px-8">
            //   <div>{t("items.soldOut")}</div>
            // </div>
          )}
        </div>
        <div>
          <Price value={cartItem.totalSalesPriceTaxInclusive} />
        </div>
        <ul className="list-disc text-xs font-normal">
          {cartItem.itemMods.map((mod) => mod.name).join(", ")}
        </ul>
      </div>
      <div>
        <div className="flex items-center gap-2 rounded-full bg-venue-secondary px-2 py-2">
          {cartItem.multiplier > 1 ? (
            <a
              className="cursor-pointer p-4"
              onClick={updateMultiplier(cartItem.multiplier - 1)}
            >
              <MdRemove className="text-lg" />
            </a>
          ) : (
            <a
              className="cursor-pointer p-4 text-lg text-venue-primary"
              onClick={removeOrderItem}
            >
              <MdDelete className="text-lg" />
            </a>
          )}
          <div> {cartItem.multiplier} </div>
          {canIncreaseMultiplier ? (
            <a
              className="text cursor-pointer p-4"
              onClick={updateMultiplier(cartItem.multiplier + 1)}
            >
              <MdAdd className="text-lg" />
            </a>
          ) : (
            <a className="invisible p-4">
              <MdAdd className="text-lg" />
            </a>
          )}
        </div>
      </div>
    </div>
  );
};
